const carouselSetting = {
  rewind: false,
  perPage: 2,
  perMove: 1,
  direction: 'rtl',
  drag: 'free',
  gap: '12px',
  fixedWidth: '185px',
  pagination: false,
  lazyLoad: 'nearby',
  breakpoints: {
    380: {
      perPage: 1,
    },
    480: {
      perPage: 2,
    },
    1288: {
      perPage: 4,
    },
  },
}
export default carouselSetting
